<template>
  <div>
    <el-dialog
      title="載具管理"
      :visible.sync="isDialogOpen"
      :lock-scroll="true"
      center
      @closed="clearEdit"
    >
      <div class="el-dialog__body">
        <div class="title-bar">
          <el-button
            :class="{'disable': isFromEip}"
            type="success"
            @click="addDevice"
          >
            新增載具
          </el-button>
        </div>
        <el-table
          class="newslist"
          :data="listData"
          empty-text="無綁定載具"
        >
          <el-table-column
            prop="Code"
            label="載具號碼"
          />
          <el-table-column label="備註">
            <template slot-scope="scope">
              <div v-if="isEdit !== scope.$index">
                {{ scope.row.Note }}
              </div>
              <div v-else>
                <el-input
                  ref="tempNoteInput"
                  v-model="tempNote"
                  maxlength="10"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="CreateAt"
            label="建立時間"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.CreateAt.split(':')[0] }}:{{ scope.row.CreateAt.split(':')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="操作"
            width="160"
          >
            <template slot-scope="scope">
              <div v-if="isEdit !== scope.$index">
                <el-button
                  :class="{'disable': isFromEip}"
                  size="mini"
                  plain
                  @click="goEdit(scope)"
                >
                  編輯
                </el-button>
                <el-button
                  :class="{'disable': isFromEip}"
                  size="mini"
                  type="danger"
                  plain
                  @click="delDevice(scope.row)"
                >
                  解除
                </el-button>
              </div>
              <div v-else>
                <el-button
                  size="mini"
                  type="success"
                  plain
                  @click="confirmEdit(scope.row.Id)"
                >
                  確認
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <reader
      ref="reader"
      :manual-input="false"
    />
  </div>
</template>
<script>
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
export default {
  components: {
    reader: ReadNFCBarcode
  },
  props: {
    account: Object
  },
  data () {
    return {
      isDialogOpen: false,
      isSending: false,
      listData: [],
      isEdit: null,
      tempNote: '',
      isFromEip: JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip
    }
  },
  methods: {
    openDialog () {
      this.isDialogOpen = true
    },
    clearEdit () {
      this.isEdit = null
      this.tempNote = ''
    },
    goEdit (scope) {
      if (this.isSending) {
        return false
      }
      this.isEdit = scope.$index
      this.tempNote = scope.row.Note
      this.$nextTick(() => {
        this.$refs.tempNoteInput.focus()
      })
    },
    confirmEdit (id) {
      if (this.isSending) {
        return false
      }
      this.isSending = true
      apiManagement.PutDeviceNote(id, {
        Note: this.tempNote
      })
        .then(res => {
          this.$emit('getDeviceList')
          this.clearEdit()
          setTimeout(() => {
            this.isSending = false
          }, 500)
        })
        .catch(err => {
          console.log(err.response)
          if (err.response.data.ErrorMessage.Code === 400002) {
            vobj.$alert(err.response.data.ErrorMessage.Description, '警告', {
              confirmButtonText: '確認',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            })
          }
          setTimeout(() => {
            this.isSending = false
          }, 500)
        })
    },
    addDevice () {
      if (this.listData.length < 3) {
        this.nfcOpen('open')
      } else {
        this.$alert('帳號綁定卡片數已達上限！', '警告', {
          confirmButtonText: '確認',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        })
      }
    },
    delDevice (scope) {
      this.$confirm(`確定要從${this.account.Name}帳號下解除此載具嗎？`, '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        this.nfcOpen('delete', scope)
      }).catch(() => {
        console.log('delete fail')
      })
    },
    nfcOpen (type, scope) {
      const vobj = this
      this.$refs.reader.getCode((code) => {
        sandAPI(code)
        function sandAPI (code) {
          const codeList = []
          let nowInd = 0
          if (typeof (code) === 'string') { codeList.push(code) } else { code.map(val => codeList.push(val)) }
          if (codeList[nowInd].length < 5) {
            vobj.$alert('載具格式錯誤，請再次感應卡片', '警告', {
              confirmButtonText: '確認',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false,
              callback: action => {
                vobj.$refs.reader.resetInput()
              }
            })
            return false
          }
          API()
          function API () {
            console.log(`ind:${nowInd}`)
            if (type === 'open') {
              apiManagement.PostDevice(vobj.account.Id, {
                Code: codeList[nowInd]
              }).then(res => {
                vobj.$message({ message: '卡片已綁定成功', type: 'success' })
                nowInd++
                if (nowInd <= codeList.length - 1) {
                  API()
                } else {
                  vobj.$emit('getDeviceList')
                  vobj.$emit('setDeviceCount', { id: vobj.account.Id, count: 1 })
                  vobj.$refs.reader.close()
                }
              }).catch(err => {
                vobj.$refs.reader.resetInput()
              })
            } else {
              if (codeList[nowInd] === scope.Code) {
                apiManagement.DeleteDevice(scope.Id, {
                  Code: codeList[nowInd]
                }).then(res => {
                  vobj.$message({ message: '卡片解除成功', type: 'success' })
                  nowInd++
                  if (nowInd <= codeList.length - 1) {
                    API()
                  } else {
                    vobj.$emit('getDeviceList')
                    vobj.$emit('setDeviceCount', { id: vobj.account.Id, count: -1 })
                    vobj.$refs.reader.close()
                  }
                }).catch(err => {
                  vobj.$refs.reader.resetInput()
                })
              } else {
                vobj.$alert('刷卡卡片與欲解除載具不符！', '警告', {
                  confirmButtonText: '確認',
                  type: 'warning',
                  showClose: false,
                  roundButton: true,
                  closeOnClickModal: false,
                  callback: () => {
                    vobj.$refs.reader.resetInput()
                  }
                })
              }
            }
          }
        }
      },
      'NFC'
      )
    }
  }
}
</script>
<style lang="sass" scoped>
::v-deep .el-dialog__wrapper
  overflow: hidden
::v-deep .el-dialog
  +basicDialog
  overflow: auto
  max-height: 80%
  .el-dialog__body
    padding: 12px
    .title-bar
      margin-bottom: 20px
      display: flex
      justify-content: flex-end
.newslist
  font-size: 15px
  .cell
    +NewsStatusTag
  .news-title
    cursor: pointer
    color: $mainColorDark
    text-decoration: underline
  ::v-deep .el-table
    +basicTable

</style>
